





















import wrappers from '@/mixins/wrappers'
import ContactCard from '@components/ContactCard.vue'
import ContactCardPlaceholder from '@components/placeholders/ContactCardPlaceholder.vue'
import mixins from 'vue-typed-mixins'
import { User } from '@/types'

export default mixins(wrappers).extend({
  name: 'Connect',
  components: {
    ContactCard,
    ContactCardPlaceholder
  },
  data () {
    return {
      colors: ['#00467f', '#50736f', '#50e3c2', '#48b8d2', '#ff2f92', '#78379d'],
      loading: false
    }
  },
  computed: {
    assignees (): User.API.ReqRes.UserContacts.Assignee {
      return this.$store.getters['user/contacts/assignees']
    },
    wrapped (): Record<string, any> {
      return {
        refresh: this.offlineWrapper(this.refresh)
      }
    }
  },
  async mounted () {
    await this.wrapped.refresh()
  },
  methods: {
    async refresh () {
      this.loading = true
      try {
        await this.$store.dispatch('user/contacts/getAllContacts')
      }
      finally {
        this.loading = false
      }
    }
  }
})
